import { render, staticRenderFns } from "./InsCurrentTab0.vue?vue&type=template&id=fa5a76b2&scoped=true&"
import script from "./InsCurrentTab0.vue?vue&type=script&lang=ts&"
export * from "./InsCurrentTab0.vue?vue&type=script&lang=ts&"
import style0 from "./InsCurrentTab0.vue?vue&type=style&index=0&id=fa5a76b2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa5a76b2",
  null
  
)

export default component.exports